import {
  toggleButtonGroupClasses as muiToggleButtonGroupClasses,
  ToggleButtonGroupClasses as MuiToggleButtonGroupClasses,
  getToggleButtonGroupUtilityClass,
} from '@mui/material';

declare module '@mui/material/ToggleButton' {
  interface ToggleButtonPropsSizeOverrides {
    extraSmall: true;
  }

  interface ToggleButtonClasses {
    sizeExtraSmall: string;
  }
}

declare module '@mui/material/ToggleButtonGroup' {
  interface ToggleButtonGroupPropsSizeOverrides {
    extraSmall: true;
  }

  interface ToggleButtonGroupClasses {
    sizeExtraSmall: string;
    colorVariantTonal: string;
    colorVariantText: string;
    colorVariantStrong: string;
  }
}

export const toggleButtonGroupClasses: MuiToggleButtonGroupClasses = {
  ...muiToggleButtonGroupClasses,
  colorVariantTonal: getToggleButtonGroupUtilityClass('colorVariantTonal'),
  colorVariantText: getToggleButtonGroupUtilityClass('colorVariantText'),
  colorVariantStrong: getToggleButtonGroupUtilityClass('colorVariantStrong'),
};
